export const CLASS_NAME = 'cst-fixed-content-header'
